import { Component, Inject, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Cinema } from '../../../models/cinema';
import { StarRatingComponent } from '../../shared/components/star-rating/star-rating.component';

@Component({
  selector: 'app-cinema-detalhe-modal',
  templateUrl: './cinema-detalhe-modal.component.html',
  styleUrls: ['./cinema-detalhe-modal.component.css'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CommonModule, StarRatingComponent],
})
export class CinemaDetalheModalComponent {

  @Input() filme!: Cinema;

  constructor(
    public activeModal: NgbActiveModal,
    @Inject('BASE_URL') private baseUrl: string,
  ) { }

  get elencoTags(): string[] {
    if (!this.filme?.elenco) return [];
    return this.filme.elenco.split(',').map(s => s.trim()).filter(Boolean);
  }

  getImagemUrl(fileServerName?: string): string {
    if (!fileServerName) return '';

    if (/^https?:\/\//i.test(fileServerName)) return fileServerName;

    const normalizedBaseUrl = this.baseUrl.endsWith('/') ? this.baseUrl : `${this.baseUrl}/`;
    return `${normalizedBaseUrl}uploads/cinema/${fileServerName}`;
  }
}
